import React, { createContext, useState } from 'react';
import { removeLocalStorage, setLocalStorage } from '../helpers/localStorage';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [openItemPreviewModal, setOpenItemPreviewModal] = useState(false);
  const [openDeleteProductModal, setOpenDeleteProductModal] = useState(false);
  const [logOutModal, setLogOutModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [openDropDownProducts, setOpenDropDownProducts] = useState(false);
  const [openDropDownAdmin, setOpenDropDownAdmin] = useState(false);

  const login = (userData) => {
    // Perform login logic and set the user state
    setUser(userData);
    setIsLoggedIn(true);
  };

  const logout = () => {
    // Perform logout logic and clear the user state
    setUser(null);
    setIsLoggedIn(false);
    removeLocalStorage('identifynadmintoken');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoggedIn,setIsLoading, isLoading, setNotification, notification, setOpenAddressModal, openAddressModal, setOpenItemPreviewModal, openItemPreviewModal, setOpenDeleteProductModal, openDeleteProductModal, logOutModal, setLogOutModal, selectedAddress, setSelectedAddress, openDropDownProducts, setOpenDropDownProducts, openDropDownAdmin, setOpenDropDownAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};